module.exports = __webpack_public_path__ + "img/50_45.c8b7f16a.png";